import { type AxiosResponse } from 'axios'

import { type CustomAxiosConfig } from '@/types/axios'
import { type Localization } from '@/types/Localization'

import armSecureAxios from './secure-base'

export const fetchAllLocalizations = async (config?: CustomAxiosConfig): Promise<AxiosResponse<Localization[]>> => {
  return await armSecureAxios.get('/translations/all', { ...config })
}

const localizationArmService = {
  fetchAllLocalizations
}

export default localizationArmService
